import {
  type Dispatch,
  type ReactElement,
  type ReactNode,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

// AC-DFC-009 (demand-forecast-danmen-guard、PR #4945 レビュー指摘対応):
// 需要想定日次画面 (`/demand/forecast-daily?workflowId=…`) のケース (計画断面) 切替は
// 実運用では DemandForecastList → DemandForecastDaily の別 mount 経由で行われる
// (Daily 画面内に断面切替 UI が無く、List 側のケース行リンクが SoT。計画断面は
// ケースの対象日と今日 (JST) の差で判定する)。
// このため DemandForecastDailyPage 内の useState では 断面往復越しに hiddenKeys が
// リセットされ、AC-DFC-009 の「断面切替で維持」を満たせない。
// App root に本 Provider を置くことで DemandForecastDailyPage の mount / unmount を
// 跨いで hiddenKeys を保持しつつ、ブラウザ再読込 (App 自体の再マウント) で既定 ON
// (new Set()) に戻す (= spec の「既定 ON への復帰はブラウザ再読み込み時」を満たす)。
type DemandForecastLegendHiddenKeysContext = {
  hiddenKeys: Set<string>
  setHiddenKeys: Dispatch<SetStateAction<Set<string>>>
}

const DemandForecastLegendHiddenKeysCtx =
  createContext<DemandForecastLegendHiddenKeysContext | null>(null)

export const DemandForecastLegendProvider = ({
  children,
}: {
  children: ReactNode
}): ReactElement => {
  const [hiddenKeys, setHiddenKeys] = useState<Set<string>>(
    () => new Set<string>(),
  )
  return (
    <DemandForecastLegendHiddenKeysCtx.Provider
      value={{ hiddenKeys, setHiddenKeys }}
    >
      {children}
    </DemandForecastLegendHiddenKeysCtx.Provider>
  )
}

export const useDemandForecastLegendHiddenKeys =
  (): DemandForecastLegendHiddenKeysContext => {
    const ctx = useContext(DemandForecastLegendHiddenKeysCtx)
    if (ctx === null) {
      throw new Error(
        'useDemandForecastLegendHiddenKeys must be used within DemandForecastLegendProvider',
      )
    }
    return ctx
  }
